import moment from "moment/moment";

export const SESSION_TIME_MINUTES = 60 * 24 * 28;

/**
 * Checks whether session was established or not
 * @returns {boolean} state
 */
export function is() {
  return (localStorage.auth_token && localStorage.auth_token.length > 0) ||
    false;
}

/**
 * Stores a token
 * @param {string} token - session token
 * @returns {void}
 */
export function store(token) {
  localStorage.auth_token = token;
  localStorage.created = moment()
    .add(Number(SESSION_TIME_MINUTES), "minutes")
    .format("YYYY-MM-DD HH:mm:ss");
}

/**
 * Clears a token
 * @returns {void}
 */
export function clear() {
  localStorage.auth_token = "";
  localStorage.created = "";
}

/**
 * Gets token
 * @returns {string} token
 */
export function getToken() {
  return localStorage.auth_token;
}
